import { RouteRecordRaw } from 'vue-router';

const authRoutes: Array<RouteRecordRaw> = [
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/dashboard/DashboardPage.vue'),
        meta: { auth: true },
        props: false
    },
    {
        path: '/transactions',
        name: 'transactions',
        component: () => import('../views/transactions/TransactionsPage.vue'),
        meta: { auth: true },
        props: false
    },
    {
        path: '/payment-methods',
        name: 'paymentMethods',
        component: () => import('../views/payment-methods/PaymentMethodsPage.vue'),
        meta: { auth: true },
        props: false
    },
    {
        path: '/recurring-gifts',
        name: 'recurringGifts',
        component: () => import('../views/recurringGifts/RecurringGiftsPage.vue'),
        meta: { auth: true },
        props: false
    },
    {
        path: '/profile',
        name: 'profile',
        redirect: { name: 'profile.index' },
        component: () => import('../views/profile/Profile.vue'),
        meta: { auth: true },
        props: false,
        children: [
            {
                path: '',
                name: 'profile.index',
                component: () => import('../views/profile/sections/ProfileView.vue'),
                props: false
            },
            {
                path: 'edit',
                name: 'profile.edit',
                component: () => import('../views/profile/sections/ProfileEdit.vue'),
                props: false
            }
        ]
    }
];

export default authRoutes;
